import styled from 'styled-components';
import { Spin, Card, Col, Row } from 'antd';

export const Spinner = styled(Spin)`
  margin: auto;
`;

export const ContentWrapper = styled(Row)`
  margin: 12px;
  display: flex;
  min-height: calc(100% - 99px);
`;

export const StyledCard = styled(Card)`
  &:not(:last-child) {
    margin-bottom: 2rem;
  }
`;

export const MapCol = styled(Col)`
  margin-left: 12px;
  height: calc(100vh - 170px);
`;

export const LeftCol = styled(Col)`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 165px);
  overflow: auto;
`;
